module.exports = __webpack_public_path__ + "img/hr-green-desert-bush-00.f45d1868.png";